(function ($) {
    var currentWebinarPage = 1;
    var webinarAjax = null;
    var ajaxTimeout = null;
    var filters = [];
    var template = $('#js-webinar-item').html();
    var templatelist = $('#js-webinar-item-list').html();
    var infoCount = $('#webinar-count');

    var loadWebinar = function () {
        var $loader = $('.js-webinar-loader');
        var $list = $('.js-webinar-list');
        var $list2 = $('.js-webinar-list2');
        var $loadMore = $('.js-webinar-next-page');

        Mustache.parse(template);

        Mustache.parse(templatelist);

        var data = {
            page: currentWebinarPage,
            nonce: rissb_var.nonces.get_webinars,
        };

        if (window.matchMedia('(max-width: 768px)').matches) {
            data.filters = $('.filter-mobile .js-webinar-filters :input').serialize();
        } else {
            data.filters = $('.js-webinar-year-filter:checkbox:checked, .js-central-topic-filter:checkbox:checked, .js-central-category-filter:checkbox:checked').serialize();
        }

        data.searchString = $('#search-webinar').val();

        data.sort = $('input[name="sort[]"]').serialize();

        if (data.page == 1) {
            $loader.removeClass('d-none');
            $list.empty();
            $list2.empty();
        }

        if (webinarAjax) {
            webinarAjax.abort();
        }

        webinarAjax = $.post('/api/webinars', data, function (res) {
            var rendered = Mustache.render(template, res.data);

            var rendered2 = Mustache.render(templatelist, res.data);

            $loader.addClass('d-none');

            // List rendering
            $list.html(rendered);

            $list2.html(rendered2);

            $(rendered).imagesLoaded(function () {
                $.fn.matchHeight._apply('[data-mh="card-webinar"]');
            });

            $(rendered2).imagesLoaded(function () {
                $.fn.matchHeight._apply('[data-mh="card-webinar"]');
            });

            // Pagination
            generatePagination(res.data.pagination);

            // Update count
            infoCount.text(res.data.data.length);

        }).always(function () {
            $loadMore.text($loadMore.data('text-original'));
        });
    };

    var generatePagination = function (pagination) {

        var pages = '';
        for (var index = 1; index <= pagination.total; index++) {
            if (pagination.current === index) {
                pages += '<li class="page-item list-inline-item"><a class="page-link active" href="#' + index + '">' + index + '</a></li>';
            }
            else {
                pages += '<li class="page-item list-inline-item"><a class="page-link" href="#' + index + '">' + index + '</a></li>';
            }
        }

        var listElement = '<ul class="pagination list-inline list-unstyled text-center">' +
            '<li class="page-item list-inline-item"><a class="page-link" href="#prev"><i class="fas text-secondary fa-arrow-left"></i></a></li>' +
            pages +
            '<li class="page-item list-inline-item"><a class="page-link" href="#next"><i class="fas text-secondary fa-arrow-right"></i></a></li>' +
            '</ul>';

        $('#webinar-pagination').html(listElement);
    };

    $(document).ready(function () {

      $( "#show-list" ).click(function() {
        $('.js-webinar-list').hide();
        $('.js-webinar-list2').show();
      });

      $( "#show-grid" ).click(function() {
        $('.js-webinar-list').show();
        $('.js-webinar-list2').hide();
      });

        if ($('body').hasClass('post-type-archive-webinar')) {
            RISSB.fn.clearDropdownFilter(function () {
                currentWebinarPage = 1;
                loadWebinar();
            });

            if ($('.js-webinar-list').length) {
                currentWebinarPage = 1;
                loadWebinar();
            }

            $('.js-webinar-year-filter, .js-central-topic-filter, .js-central-category-filter').on('change', function (evt) {
                loadWebinar();
            });

            $('input[name="sort[]"]').on('change', function (evt) {
                loadWebinar();
            });

            $(document).on('click', '.page-link', function (evt) {
                var selectedPage = $(this).attr('href').replace('#', '');

                if (selectedPage === 'prev') {
                    currentWebinarPage--;
                }
                else if (selectedPage === 'next') {
                    currentWebinarPage++;
                }
                else {
                    currentWebinarPage = selectedPage;
                }

                loadWebinar();
            });

            $('.js-search-submit').on('click', function (evt) {
                evt.preventDefault();

                loadWebinar();
            })

            $('.js-webinar-filters').find('.js-webinar-search').on('keyup input', function () {
                currentWebinarPage = 1;

                clearTimeout(ajaxTimeout);
                ajaxTimeout = setTimeout(loadWebinar, 500);
            });

            $('.js-update-filter').on('click', function () {
                var $this = $(this);
                currentWebinarPage = 1;

                RISSB.fn.updateQSParams('news_categories[]', $this.closest('.js-webinar-filters').find('input[name="news_categories[]"]:checked').map(function () {
                    return $(this).val();
                }).get(), true);

                loadWebinar();
                $this.closest('.dropdown-menu').removeClass('show');
            });

            $('.js-webinar-next-page').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentWebinarPage = currentWebinarPage + 1;

                $this.html('<i class="fas fa-spinner fa-spin fa-fw"></i> ' + $this.data('text-progress'));
                loadWebinar();
            });

            $('.js-webinar-list').on('click', '.js-filter-category', function (e) {
                e.preventDefault();

                var $this = $(this);

                $('.js-dropdown-filter-category').find('[type="checkbox"][name="news_categories[]"]').prop('checked', false);
                $('.js-dropdown-filter-category').find('[type="checkbox"][name="news_categories[]"][value="' + $this.data('id') + '"]').prop('checked', true).change();
                RISSB.fn.updateQSParams('news_categories[]', $this.data('id'));

                currentWebinarPage = 1;

                loadWebinar();
            });

            $('.js-dropdown-sort').on('click', '.dropdown-item', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentWebinarPage = 1;

                $('[name="orderby"]').val($this.data('orderby'));
                $('[name="order"]').val($this.data('order'));
                $('.js-order-type').text($this.text());

                loadWebinar();
            });

            $('.js-webinar-list').on('click', '.card-news-style-1, .card-news-style-2', function (e) {
                if ($(e.target).hasClass('js-filter-category')) {
                    return;
                }

                window.location = $(this).find('.card-news-read-more').attr('href');
            });
        }

        if ($('body').hasClass('single-news')) {
            $('.is-sticky').stick_in_parent({
                offset_top: $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,
            });

            $content = $('.post-content');

            if ($content.find('iframe').length) {
                var contentSelector = 'div.header, .layout, .one-col .column';

                $content.find('iframe').each(function () {
                    var $iframe = $(this);

                    $iframe.removeAttr('width');
                    $iframe.css('width', '100%');
                });
            }
        }
    });
})(jQuery);
